/*
 * Shoplift → cart attribute (test A/B seuil de livraison)
 * --------------------------------------------------------
 * À intégrer dans le THÈME (pas dans l'app fonction).
 * Détecte la variante assignée par Shoplift et la persiste dans un cart
 * attribute lu par la Shopify Function `shipping-ab-test`.
 *
 * Intégration possible :
 *   - copier ce fichier dans GLOBAL/shop/assets/ et l'inclure via
 *     {{ 'shoplift-shipping-ab.js' | asset_url | script_tag }} dans theme.liquid,
 *   - ou coller son contenu dans ton bundle JS existant.
 *
 * ⚠️ À renseigner : les 2 HypothesisIDs générés par ton test JS API Shoplift.
 */
(function () {
  "use strict";

  // Doit correspondre à ATTRIBUTE_KEY dans la fonction (src/run.js).
  var ATTRIBUTE_KEY = "_shoplift_shipping";

  // 👉 Remplace par les HypothesisIDs de ton test Shoplift.
  var HYPOTHESES = {
    control: "019fbeb9-1a33-7863-9263-033ba8099fc3",
    variant: "019fbeb9-1cbb-72e5-92dd-d510744c2fd5",
  };

  function log() {
    var args = ["[Shoplift AB]"].concat(Array.prototype.slice.call(arguments));
    console.log.apply(console, args);
  }

  // Attend que window.shoplift soit prêt (max ~10 s).
  function waitForShoplift() {
    return new Promise(function (resolve) {
      if (window.shoplift && typeof window.shoplift.isHypothesisActive === "function") {
        return resolve(window.shoplift);
      }
      var tries = 0;
      var iv = setInterval(function () {
        tries++;
        if (window.shoplift && typeof window.shoplift.isHypothesisActive === "function") {
          clearInterval(iv);
          resolve(window.shoplift);
        } else if (tries > 100) {
          clearInterval(iv);
          resolve(null);
        }
      }, 100);
    });
  }

  async function getCurrentAttribute() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return (cart && cart.attributes && cart.attributes[ATTRIBUTE_KEY]) || null;
      })
      .catch(function () { return null; });
  }

  function setAttribute(value) {
    var body = { attributes: {} };
    body.attributes[ATTRIBUTE_KEY] = value;
    return fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body),
    });
  }

  function assign() {
    log("démarrage, attente de window.shoplift…");
    waitForShoplift().then(function (sl) {
      if (!sl) {
        log("⚠️ window.shoplift introuvable après 10 s — abandon (app Shoplift chargée ?)");
        return;
      }
      log("window.shoplift prêt, vérification des hypothèses…", HYPOTHESES);
      // Détermine la variante active.
      Promise.all([
        sl.isHypothesisActive(HYPOTHESES.control),
        sl.isHypothesisActive(HYPOTHESES.variant),
      ]).then(function (res) {
        log("isHypothesisActive → control:", res[0], "| variant:", res[1]);
        var value = null;
        if (res[0]) value = "control";
        else if (res[1]) value = "variant";
        if (!value) {
          log("visiteur hors test (aucune hypothèse active) → cart attribute non modifié");
          return; // visiteur hors test → on ne force rien
        }
        log("hypothèse sélectionnée :", value, "(" + HYPOTHESES[value] + ")");

        getCurrentAttribute().then(function (current) {
          log("cart attribute actuel", ATTRIBUTE_KEY, "=", current);
          if (current === value) {
            log("attribut déjà à jour → rien à faire");
            return; // déjà positionné
          }
          log("mise à jour du cart attribute →", value);
          setAttribute(value)
            .then(function (r) {
              if (r.ok) {
                log("✅ cart attribute écrit :", ATTRIBUTE_KEY, "=", value);
              } else {
                log("⚠️ échec écriture cart attribute (HTTP " + r.status + ")");
              }
            })
            .catch(function (err) {
              log("⚠️ erreur réseau lors de l'écriture du cart attribute :", err);
            });
        });
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", assign);
  } else {
    assign();
  }
})();